import { render, staticRenderFns } from "./Public-Edit-Doc-File.vue?vue&type=template&id=ba088966&scoped=true&"
import script from "./Public-Edit-Doc-File.vue?vue&type=script&lang=js&"
export * from "./Public-Edit-Doc-File.vue?vue&type=script&lang=js&"
import style0 from "./Public-Edit-Doc-File.vue?vue&type=style&index=0&id=ba088966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba088966",
  null
  
)

export default component.exports